import React from "react";
import { NavLink } from "react-router-dom";
import { navigationGroups } from "../../services/constants/navigation";

const Sidebar: React.FC = () => {
    return (
        <aside className="sidebar">
            <div className="sidebar-brand">
                <div className="sidebar-brand-mark">S</div>
                <div>
                    <p className="sidebar-brand-title">ShowMust</p>
                    <p className="sidebar-brand-subtitle">Admin Panel</p>
                </div>
            </div>

            <nav className="sidebar-nav" aria-label="Основная навигация">
                {navigationGroups.map((group) => (
                    <div key={group.title} className="sidebar-group">
                        <p className="sidebar-group-title">{group.title}</p>

                        <div className="sidebar-links">
                            {group.items.map((item) => (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    end={item.path === "/"}
                                    className={({ isActive }) =>
                                        `sidebar-link ${isActive ? "sidebar-link-active" : ""}`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default Sidebar;
